import script from "./ApplicationCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationCenter.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationCenter.vue?vue&type=style&index=0&id=3073cfd0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3073cfd0"]])

export default __exports__